import { fromJS } from 'immutable'
import { LOCATION_CHANGE } from 'react-router-redux'


import {
  UPDATE_ID,
  CHANGE_STEP,
  UPDATE_DATASET_VALUE,
  VEHICLE_DATASET,
  DOCUMENTS_DATASET,

  RESET_STATE,
} from './constants'


export const initialState = fromJS({
  currentStep: 0,
  vehicleId: null,
  policyId: null,
  [VEHICLE_DATASET]: {
    maker: null,
    brand: null,
    model: null,
    engine_id: '',
    serial_number: '',
    plates: ''
  },
  [DOCUMENTS_DATASET]: {
    driver_license_file: null,
    vehicle_card_file: null,
    vehicle_invoice_file: null
  }
})


export default function reducer(state = initialState, action) {
  switch(action.type) {
    case UPDATE_ID:
      return state.set(action.name, action.id)
    case CHANGE_STEP:
      return state.set('currentStep', action.step)
    case UPDATE_DATASET_VALUE:
      let prevData = state.get(action.dataset)
      prevData = prevData.set(action.name, action.value)
      return state.set(action.dataset, prevData)
    case LOCATION_CHANGE:
      return initialState
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/reducer.js